module.exports = __webpack_public_path__ + "static/media/nl.e53fc83f.svg";